export function stringToHTML(str) {
    var tempNode = document.createElement('div');
    tempNode.innerHTML = str;
    return tempNode.firstChild;
}
export function parseHTML(element) {
    if (typeof element === 'string') {
        return stringToHTML(element);
    }
    return element;
}
//# sourceMappingURL=html.js.map